/** The font size the console pins its root to, which a test environment without styles falls back to. */
const DESIGN_ROOT_PX = 12;

/**
 * The root font size in pixels, as the browser has it now. The console re-bases it at wider viewports, so a width in rem
 * grows with it where one in px would not.
 */
export const rootFontPx = (): number =>
  parseFloat(getComputedStyle(document.documentElement).fontSize) ||
  DESIGN_ROOT_PX;

/** A length measured in pixels, as rem against the root font size now. */
export const pxToRem = (px: number): string =>
  `${Math.round((px / rootFontPx()) * 10000) / 10000}rem`;
